import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component<AnimatedNumber>({})
export default class AnimatedNumber extends Vue {
  @Prop({ default: 0 })
  protected number?: number;

  @Prop()
  protected label?: string;

  protected displayNumber = 0;

  protected interval = 0;

  protected mounted(): void {
    this.numberChanged();
  }

  @Watch('number')
  protected numberChanged(): void {
    if (! this.number) {
      return;
    }

    clearInterval(this.interval);

    const number = this.number;

    if (number === this.displayNumber) {
      return;
    }

    this.interval = window.setInterval(() => {
      if (this.displayNumber !== this.number) {
        let change = (number - this.displayNumber) / 10;
        change = change >= 0 ? Math.ceil(change) : Math.floor(change);
        this.displayNumber += change;
      }
    }, 40);
  }
}
